
import React from 'react';

const WhyChooseUsSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">
            Why HP Inc consulting services?
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Comprehensive OSHA Consulting Services
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              HP Inc consulting services offers a wide range of OSHA consulting services tailored to meet the unique needs of different industries, including construction, manufacturing, power, oil & gas, environmental, sanitation, retail, and quasi-public corporations. We've designed our services to be flexible and adaptable, ensuring we meet your specific requirements and budget constraints.
            </p>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://safetyconsultantsusa.com/wp-content/uploads/2024/08/osha-consulting.jpg"
              alt="OSHA Consulting"
              className="rounded-lg shadow-lg max-w-full h-auto"
            />
          </div>
        </div>

        <div className="text-center mb-12">
          <a 
            href="#contact-form" 
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
          >
            Contact Us
          </a>
        </div>

        <div className="bg-gray-50 rounded-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Experienced Consultants
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed text-center max-w-4xl mx-auto">
            Our team comprises highly experienced OSHA Outreach Trainers and safety professionals with extensive industry knowledge. Our team members are W2 employees, so they are 100% dedicated to meeting client expectations and serving our clients proactively. They work directly with you to develop, implement, and manage effective safety programs, conduct thorough site assessments, and provide specialized training.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
